/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type SearchRunSchemaExternalPhase = typeof SearchRunSchemaExternalPhase[keyof typeof SearchRunSchemaExternalPhase];


export const SearchRunSchemaExternalPhase = {
  searching: 'searching',
  ranking: 'ranking',
  ready: 'ready',
  failed: 'failed',
  cancelled: 'cancelled',
} as const;
